import { gql } from '@apollo/client';
import CLASSROOM_FRAGMENT from 'graph/fragments/classroom';

const GET_MY_CLASSROOMS = gql`
  query getMyClassrooms($whereUser: UsersWhereInput) {
    classrooms(whereUser: $whereUser, orderBy: { field: NAME, direction: ASC }) {
      ...BaseClassroom
      organization {
        id
        name
      }
    }
  }
  ${CLASSROOM_FRAGMENT}
`;

export default GET_MY_CLASSROOMS;
